export enum HEY_SYNCLY_MESSAGE_TYPE {
  QUESTION = 'QUESTION',
  ANSWER = 'ANSWER',
}

export enum HEY_SYNCLY_STATUS {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum HEY_SYNCLY_ANSWER_STATUS {
  UNDERSTANDING = 'UNDERSTANDING',
  ANALYZING = 'ANALYZING',
  REFINING = 'REFINING',
  REASONING = 'REASONING',
  GENERATING = 'GENERATING',
  COMPLETE = 'COMPLETE',
  FAIL = 'FAIL',
}

export enum HEY_SYNCLY_SOURCE_TYPE {
  WEB = 'WEB',
  SLACK = 'SLACK',
  CHART = 'CHART',
  SEARCH = 'SEARCH',
  INSIGHT = 'INSIGHT',
  SIGNAL = 'SIGNAL',
}

export const HeySynclyAnswerStatusMap = new Map<
  HEY_SYNCLY_ANSWER_STATUS,
  string
>([
  [HEY_SYNCLY_ANSWER_STATUS.UNDERSTANDING, 'Understanding your request...'],
  [HEY_SYNCLY_ANSWER_STATUS.ANALYZING, 'Analyzing feedback...'],
  [HEY_SYNCLY_ANSWER_STATUS.REFINING, 'Extracting insights...'],
  [HEY_SYNCLY_ANSWER_STATUS.REASONING, 'Thinking...'],
  [HEY_SYNCLY_ANSWER_STATUS.GENERATING, 'Generating results...'],
  [HEY_SYNCLY_ANSWER_STATUS.COMPLETE, 'Complete'],
  [
    HEY_SYNCLY_ANSWER_STATUS.FAIL,
    'Failed to generate results. Please try again.',
  ],
]);
